import { classNames } from 'primereact/utils';

export const TooltipTailwindThemes = {
  tooltip: {
    root: {
      // PrimeReact zeroes the root's padding while it measures for viewport collisions, so
      // horizontal padding on the root makes the tooltip wider than measured and it can overflow.
      className: classNames(
        'absolute z-[10000] w-max max-w-[min(25rem,80vw)] rounded-sm border border-fletchers-gray-110 bg-fletchers-white py-2 *:px-3 text-left text-sm text-fletchers-black shadow-sm',
      ),
    },
    text: {
      className: 'whitespace-normal break-words',
    },
    arrow: {
      className: 'hidden',
    },
  },
};
